import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Typography, Checkbox } from "@mui/material";
// import { styled, alpha } from "@mui/material/styles";
// import InputBase from "@mui/material/InputBase";
import BetterAnswerModal from "../BetterAnswerModal/BetterAnswerModal";
import QuestionsAndAnswers from "../QuestionsAndAnswers/QuestionsAndAnswers";
import styles from "./SessionQuestions.module.css";
import { useState } from "react";
import QuestionBoxInScore from "../QuestionBoxInScore.js/QuestionBoxInScore";

const SessionQuestions = ({
  open,
  setOpen,
  fromRating,
  dataObjects,
  Id,
  SessionId,
  IdName,
  rerender,
  setRerender,
  handleCheckboxChange,
  isChecked,
}) => {
  const [questionId, setQuestionId] = useState(1);
  const [question, setQuestion] = useState("");
  const [showQuestion, setShowQuestions] = React.useState(false);


  const getResults = async (question) => {
    return fetch(
      `${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?BotId=${Id}&Question=${question}`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    ).then((data) => data.json());
  };

  const getQAs = async (question) => {
    if (IdName == "DataId") {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/searchQAs/?DataId=${Id}&Question=${question}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    } else {
      return fetch(
        `${process.env.REACT_APP_API_ROOT}/api/data/searchQAs/?SourceId=${Id}&Question=${question}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      ).then((data) => data.json());
    }
  };

  return (
    <>
      <div>
        <div
          className="flex flex-col gap-4 mt-4"
          onClick={() => setShowQuestions(!showQuestion)}
        >
          <div
            className="border p-4 w-full"
            style={{
              borderRadius: "5px",
              border: "1px solid rgba(0, 0, 0, 0.30)",
              background: "#F7F8FC",
            }}
          >
            Session ID : {SessionId}
          </div>
        </div>
      </div>
      {showQuestion ? (
        <div>
        

          <QuestionsAndAnswers
            questionId={questionId}
            fromRating={fromRating}
            setQuestionId={setQuestionId}
            open={open}
            setOpen={setOpen}
            dataObjects={dataObjects}
            Id={Id}
            rerender={rerender}
            setRerender={setRerender}
          />
        
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SessionQuestions;
